import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function ThankYouPage() {
  const { state } = useLocation();
  const ref = state?.reference || 'APP-XXXXX';

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <nav style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)', padding: '0 20px', height: 54, display: 'flex', alignItems: 'center' }}>
        <span style={{ fontWeight: 700, color: 'var(--accent3)' }}>Adeona Technologies</span>
      </nav>
      <div style={{ maxWidth: 480, margin: '0 auto', padding: '48px 24px', textAlign: 'center' }}>
        <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'var(--accent2)', color: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: 28 }}>✓</div>
        <h1 style={{ fontSize: 24, marginBottom: 8 }}>Application Received!</h1>
        <p style={{ color: 'var(--text2)', marginBottom: 24 }}>
          Thank you for applying to the Adeona SME Digital Empowerment Initiative.
        </p>
        <div style={{ background: 'var(--surface2)', borderRadius: 'var(--r)', padding: 16, marginBottom: 16 }}>
          <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '.5px' }}>Your Reference</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--accent3)' }}>#{ref}</div>
        </div>
        <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 16, textAlign: 'left', marginBottom: 12 }}>
          <h4 style={{ fontSize: 14, marginBottom: 6 }}>📅 What happens next?</h4>
          <p style={{ fontSize: 13, color: 'var(--text2)' }}>We'll review all applications after 30 June 2026 and contact shortlisted businesses for a discovery meeting. 10 businesses will be selected and publicly announced.</p>
        </div>
        <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 16, textAlign: 'left', marginBottom: 24 }}>
          <h4 style={{ fontSize: 14, marginBottom: 6 }}>💬 Free consultation</h4>
          <p style={{ fontSize: 13, color: 'var(--text2)' }}>Even if not selected, we offer a free 30-minute strategy session for all applicants. We'll reach out after the deadline.</p>
        </div>
        <Link to="/" className="btn btn--outline btn--full" style={{ borderRadius: 'var(--r)' }}>Back to Campaign</Link>
      </div>
    </div>
  );
}
